









import { Component, Prop } from 'vue-property-decorator';
import { VehicleStateItem } from '@/core/interfaces/vehicleState';
import { mixins } from 'vue-class-component';
import UsesTranslatableValue from '@/components/mixins/UsesTranslatableValue';
import SvgIcon from '@/components/SvgIcon.vue';

@Component({
    components: { SvgIcon },
})
export default class VehicleStateIconItem extends mixins(UsesTranslatableValue) {
    @Prop({ required: true })
    item!: VehicleStateItem;

    get icon(): string {
        switch (this.item.name) {
            case 'battery':
                return 'battery';
            case 'scale':
                return 'scale';
            case 'speed':
                return 'speed';
            case 'straighten':
                return 'straighten';
            default:
                return '';
        }
    }
}

